import { render } from "./Index.vue?vue&type=template&id=df56dab8"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/API/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df56dab8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df56dab8', __exports__)) {
    api.reload('df56dab8', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=df56dab8", () => {
    api.rerender('df56dab8', render)
  })

}


export default __exports__